import { Component } from '@angular/core';

@Component({
  selector: 'app-welcome',
  templateUrl: 'welcome.component.html',
})
export class WelcomeComponent {}
